import { Carousel as RootCarousel, Skeleton } from '@tecsinapse/cortex-react'
import React from 'react'
import { HomeSlideDefault } from '../ui/home-slide-default'
import { useCarousel } from '../hooks/use-carousel'

export const Carousel = ({ linkHelpTec }: { linkHelpTec?: string }) => {
  const { loading, data, images } = useCarousel()
  if (loading) return <Skeleton className={'h-[360px] w-full rounded-micro'} />
  if ((data?.slidesAtivos ?? []).length === 0)
    return <HomeSlideDefault linkHelptec={String(linkHelpTec)} />

  return (
    <div className={'w-full'}>
      {images.length > 0 ? <RootCarousel images={images} autoScroll /> : <></>}
    </div>
  )
}
